import {Action} from '@ngrx/store';
import {Benutzer} from '../../../../clients/vorlagen';

export const PAGE_STATE_RESET = '[AufgabenBerechtigungenChecklistenPage] Page State reset';
export const PAGE_DATEN_LADEN = '[AufgabenBerechtigungenChecklistenPage] Page Daten Laden';
export const SET_SELECTED_AUFGABEN = '[AufgabenBerechtigungenChecklistenPage] Set selected Aufgaben';
export const BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN = '[AufgabenBerechtigungenChecklistenPage] Benutzerberechtigungen hinzufügen';
export const BENUTZER_BERECHTIGUNGEN_ENTFERNEN = '[AufgabenBerechtigungenChecklistenPage] Benutzerberechtigungen entfernen';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;

    constructor() {
    }
}

export class PageLoadDataAction implements Action {
    readonly type = PAGE_DATEN_LADEN;

    constructor(public payload: string) {}
}

export class SetSelectedAufgabenAction implements Action {
    readonly type = SET_SELECTED_AUFGABEN;

    constructor(public payload: Array<string>) {
    }
}

export class BenutzerberechtigungenHinzufuegenAction implements Action {
    readonly type = BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN;

    constructor(public payload: Array<string>) {
    }
}

export class BenutzerberechtigungenEntfernenAction implements Action {
    readonly type = BENUTZER_BERECHTIGUNGEN_ENTFERNEN;

    constructor(public payload: Benutzer) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    PageStateResetAction
    | PageLoadDataAction
    | SetSelectedAufgabenAction
    | BenutzerberechtigungenHinzufuegenAction
    | BenutzerberechtigungenEntfernenAction;
